import { getV2ApiUrl } from '../../../../api/auth'
import { axiosRequest } from '../../../../utils/axiosRequest'

export async function fetchCampaignData(chainId: number) {
  const url = `${getV2ApiUrl()}/campaigns/getAllPromos/${chainId}`
  const res = await axiosRequest('GET', url)

  return res.data
}
